var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIcCopy = function SvgIcCopy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M760-200H320q-33 0-56.5-23.5T240-280v-560q0-33 23.5-56.5T320-920h247q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v367q0 33-23.5 56.5T760-200m0-440H620q-25 0-42.5-17.5T560-700v-140H320v560h440zM160-40q-33 0-56.5-23.5T80-120v-520q0-17 11.5-28.5T120-680t28.5 11.5T160-640v520h400q17 0 28.5 11.5T600-80t-11.5 28.5T560-40zm160-800v200zv560z"
  })));
};
export default SvgIcCopy;